import { defineStore } from 'pinia';
import CapiSettingsAPI from './api';

// Meta CAPI configuration, decided per WhatsApp channel (inbox).
// Key 0 holds the account-level fallback used by channels never configured individually.
export const useCapiStore = defineStore('wasapiCapi', {
  state: () => ({
    configs: {},
    catalog: [],
    isSaving: false,
  }),
  getters: {
    manualCatalog: state => state.catalog.filter(item => !item.automatic),
    configFor: state => inboxId => state.configs[inboxId || 0] || null,
    enabledOutcomesFor() {
      return inboxId => this.configFor(inboxId)?.enabledOutcomes || [];
    },
  },
  actions: {
    apply(inboxId, data) {
      this.configs[inboxId || 0] = {
        enabledOutcomes: data.enabled_outcomes || [],
        requireBeforeResolve: !!data.require_before_resolve,
        resolveRequiredOutcomes: data.resolve_required_outcomes || [],
        effectiveRequiredOutcomes:
          data.effective_required_outcomes || data.enabled_outcomes || [],
        inherited: !!data.inherited,
      };
      this.catalog = data.catalog || this.catalog;
    },
    async fetch(inboxId = null, force = false) {
      if (this.configFor(inboxId) && !force) return;
      const { data } = await CapiSettingsAPI.get(inboxId);
      this.apply(inboxId, data);
    },
    async save(inboxId, payload) {
      this.isSaving = true;
      try {
        const { data } = await CapiSettingsAPI.update(payload, inboxId);
        this.apply(inboxId, data);
      } finally {
        this.isSaving = false;
      }
    },
  },
});
